import React from "react";

const Hero = () => {
  return (
    <div className="border-b border-t">
      <div className="grid grid-cols-3">
        <div className="leftside mx-auto w-auto py-20 col-span-2">
          <div className="p-8 mx-auto">
            <h1 className="text-4xl lg:text-6xl font-semibold text-[#0D314F] mb-2">
              Sync Your Marketing
            </h1>
            <h1 className="text-4xl lg:text-6xl font-semibold text-[#0D314F] mb-6 block lg:flex items-center gap-2">
              Data to
              <span className="flex items-center">
                <span className="text-blue-500">G</span>
                <span className="text-red-500">o</span>
                <span className="text-yellow-500">o</span>
                <span className="text-blue-500">g</span>
                <span className="text-green-500">l</span>
                <span className="text-red-500">e</span>
                <span className="text-[#5f6368] ml-2">Workspace</span>
              </span>
            </h1>

            <p className="text-[#697586] mb-8 text-xl max-w-lg">
              With the SuperMetrics Workspace add-on, access all your connected
              marketing and sales accounts directly in Google Sheets, Slides,
              and everywhere else.
            </p>

            <div className="flex gap-4">
              <button className="bg-[#1b91f0] text-white px-4 lg:px-8 py-3 rounded-xl flex items-center gap-2 hover:bg-blue-600 transition-colors font-medium text-lg relative">
                <div className="absolute inset-0 rounded-[30px] shadow-[0_8px_40px_-12px_rgba(0,0,255,0.5)]"></div>
                <span className="relative">Install Now</span>
                <svg className="w-5 h-5 relative" fill="none" stroke="currentColor" viewBox="0 0 24 24" >
                  <path
                    strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                  />
                </svg>
              </button>
              <button className="text-[#212F40] px-6 py-2 rounded-xl border font-semibold border-slate-300 hover:bg-slate-100 transition-colors">
                Learn More
              </button>
            </div>
          </div>
        </div>
        <div className="rightside">
          <div className="relative">
            <img src="/Hero/heroimg.svg" alt="hero" className="w-full lg:block hidden h-full object-cover py-20"
            />

            <div className="absolute inset-0 bg-gradient-to-b from-transparent from-60% to-white" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
